import { render } from "./SummaryHeader.vue?vue&type=template&id=fa65b7c8"
import script from "./SummaryHeader.vue?vue&type=script&lang=js"
export * from "./SummaryHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__